export const APPLE2_RAM_BYTES = 48 * 1024;
export const APPLE2_ADDR_SPACE = 0x10000;
export const KARATEKA_PC = 0xB82A;
export const LAST_APPLE2_DUMP_KEY = 'rhdl.runner.last_memory_dump.v1';
